// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Language: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd">
                <g transform="translate(5.294)">
                    <path
                        fill="currentColor"
                        d="M42.707 23.981C42.707 10.755 31.94 0 18.712 0 12.979 0 7.646 1.938 3.286 5.615l-1.076.91V4.622a1.105 1.105 0 0 0-2.21 0v5.282c0 .608.493 1.102 1.106 1.102h5.28a1.103 1.103 0 1 0 0-2.208H3.03L4.32 7.652a21.706 21.706 0 0 1 14.391-5.445c12.012 0 21.781 9.77 21.781 21.774 0 1.698-.196 3.389-.579 5.026l.134.83c.157.252.4.432.692.499.535.137 1.188-.233 1.325-.823.427-1.797.642-3.66.642-5.532"
                    />
                </g>
                <g transform="translate(0 17.632)">
                    <path
                        fill="currentColor"
                        d="M41.605 19.36h-5.282c-.609 0-1.105.495-1.105 1.104 0 .608.496 1.106 1.105 1.106h3.363l-1.297 1.146a21.73 21.73 0 0 1-14.392 5.442c-12.011 0-21.784-9.766-21.784-21.771 0-1.698.195-3.392.58-5.026L2.66.528 1.973.032 1.71 0l-.567.16C.888.317.712.56.644.852A24.193 24.193 0 0 0 0 6.387c0 13.222 10.766 23.98 23.997 23.98 5.737 0 11.07-1.94 15.426-5.614l1.077-.91v1.903c0 .608.496 1.102 1.105 1.102.611 0 1.107-.494 1.107-1.102v-5.282c0-.609-.496-1.105-1.107-1.105"
                    />
                </g>
                <path
                    fill="currentColor"
                    d="M24.043 8.775c-7.771 0-14.408 6.061-15.113 13.796l-.054.234.022.199-.012.413-.026.537c0 8.377 6.81 15.186 15.183 15.186 8.372 0 15.182-6.809 15.182-15.186 0-8.37-6.81-15.179-15.182-15.179Zm9.977 6.903a12.862 12.862 0 0 1 2.953 7.428l.045.699-3.881.022v-.916c0-1.23-.776-2.304-1.93-2.668l-.785-.25 3.008-5.026.59.71Zm-22.588 5.285a12.985 12.985 0 0 1 7.918-9.087l.446-.173.327.38 1.265 2.529c.602 1.4.448 2.907-.343 3.54-.363.287-.814.361-1.131.367a4.17 4.17 0 0 0-2.966 1.224l-1.451 1.453c-.365.363-.87.574-1.388.574h-2.87l.193-.807Zm13.626 13.02a2.943 2.943 0 0 0-.439 2.172l.141.779-.788-.007a12.826 12.826 0 0 1-7.665-2.578l-1.23-.92 4.462-.74c.365-.06.718-.189 1.05-.387l4.162-2.338 1.226 2.639-.919 1.38Zm11.633-7.175a13.003 13.003 0 0 1-8.942 9.578l-.343.102v-.003l.07-.016-.858-.778.214-.391.78-1.163c.591-.887.659-2.028.182-2.978l-.779-1.554a2.969 2.969 0 0 0-1.829-1.531 2.939 2.939 0 0 0-2.358.304l-3.648 2.127-5.72.954-.19-.285a13.044 13.044 0 0 1-2.165-6.502l-.038-.691h3.042a4.142 4.142 0 0 0 2.951-1.221l1.451-1.457c.378-.372.87-.57 1.425-.574.952-.022 1.816-.314 2.486-.85 1.594-1.273 1.992-3.82.97-6.196l-1.29-2.572.97-.078c.34-.025.65-.047.97-.047 2.61 0 5.132.775 7.288 2.245l.371.256-.82 1.438-1.931 3.22a2.84 2.84 0 0 0-.228 2.453c.3.813.939 1.431 1.75 1.688l.364.119.09.409v.353a2.849 2.849 0 0 0 2.847 2.841h3.095l-.177.8Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Language);
